<template>
  <div>
    <v-data-table
      :headers="headers"
      :loading="isLoading"
      loading-text="Loading... Please wait"
      :items="data"
      class="elevation-1"
    >
      <template #item.name="{ item }">
        <router-link
          :to="{
            path: '/client/reports',
            query: {
              name: item.name,
              type: type,
              dealerId: dealerId,
              specificDealerId:
                specificDealerId === '0' ? item.id : specificDealerId,
            },
          }"
        >
          {{ item.name }}
        </router-link>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: ['data', 'type', 'dealerId', 'specificDealerId'],
  data() {
    return {
      isLoading: false,
      headers: [
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Assigned  Units',
          value: 'assignedUnits',
        },
        {
          text: 'Past Due Units',
          value: 'pastDueUnits',
        },
        {
          text: 'Completed Recaps',
          value: 'completed',
        },

        {
          text: 'Total Certificates',
          value: 'certificates',
        },
      ],
      pagination: {
        per_page: null,
        current_page: null,
        sortBy: 'units_completed',
        sortDesc: true,
        total: '',
      },
      filter: {
        dateRange: ['2022-03-16', '2022-03-16'],
        type: '7days',
        filterGroup: '',
        company: '',
      },
      paginationDisable: false,
      search: '',
      options: {},
    };
  },
  methods: {},
  created() {},
};
</script>
